import React from "react";
import { useSelector } from "react-redux";
import { IStore } from "@/redux/defaultStore";
import { overwolfGameInfo } from "@/hooks/useOverwolfInterop";
import { capitalizeFirstLetter } from "@/utils/formatString/capitalizeFirstLetter";
import { FaGamepad, FaTimes } from "react-icons/fa";

interface GameDetectedNotificationProps {
    gameInfo: overwolfGameInfo;
    onEnterGameMode: () => void;
    onDismiss: () => void;
    onDontShowAgain?: () => void;
}

const GameDetectedNotification: React.FC<GameDetectedNotificationProps> = ({
    gameInfo,
    onEnterGameMode,
    onDismiss,
    onDontShowAgain,
}) => {
    const isOnOverwolf = useSelector((store: IStore) => store.metaStore.isOnOverwolf);

    // Only show for Overwolf users
    if (!isOnOverwolf) {
        return null;
    }

    return (
        <div className="game-notification game-notification--detected">
            <div className="game-notification__content">
                {/* Game Icon */}
                <div className="game-notification__icon">
                    <FaGamepad size={24} />
                </div>

                {/* Message Content */}
                <div className="game-notification__message">
                    <div className="game-notification__title">
                        Game Detected!
                    </div>
                    <div className="game-notification__subtitle">
                        {capitalizeFirstLetter(gameInfo.gameTitle)} is now running.
                    </div>
                </div>

                {/* Actions */}
                <div className="game-notification__actions">
                    <button
                        className="game-notification__button game-notification__button--primary"
                        onClick={onEnterGameMode}
                    >
                        Enter Game Mode
                    </button>
                    <button
                        className="game-notification__button game-notification__button--secondary"
                        onClick={onDismiss}
                    >
                        Maybe Later
                    </button>
                    {onDontShowAgain &&
                        <button
                            className="game-notification__button game-notification__button--text"
                            onClick={onDontShowAgain}
                        >
                            Don't show again
                        </button>
                    }
                </div>

                {/* Close Button */}
                <button
                    className="game-notification__close"
                    onClick={onDismiss}
                    aria-label="Close notification"
                >
                    <FaTimes size={16} />
                </button>
            </div>

            {/* Progress indicator if GEP is starting */}
            {gameInfo.gepStarted === false &&
                <div className="game-notification__progress">
                    <div className="game-notification__progress-bar">
                        <div className="game-notification__progress-fill"></div>
                    </div>
                    <div className="game-notification__progress-text">
                        Connecting to game events...
                    </div>
                </div>
            }
        </div>
    );
};

export default GameDetectedNotification;